module.exports = "/_next/static/images/5-42eff6c2.gif";